import { PropsWithChildren } from 'react';
import { IconLogo } from 'shared/_ui/icon';
import { styled } from '@mui/material/styles';

export const AppInfoContainer = styled('div', { name: 'AppInfoContainer' })(({ theme }) => ({
	padding: theme.spacing(6),
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(8),
	alignItems: 'center',
	height: '100%',
	justifyContent: 'center',
	[theme.breakpoints.up('sm')]: {
		padding: theme.spacing(10),
	},
}));

export const AppInfoContent = styled('div', { name: 'AppInfoContent' })(({ theme }) => ({
	maxWidth: theme.spacing(80),
	width: '100%',
	'& > *:not(:first-child)': {
		marginTop: theme.spacing(6),
	},
}));

export const Logo = styled(IconLogo, { name: 'Logo' })(({ theme }) => ({
	height: theme.spacing(16),
	width: theme.spacing(16),
}));

export default function AppInfoWrapper({ children }: PropsWithChildren) {
	return (
		<AppInfoContainer>
			<Logo />
			<AppInfoContent>{children}</AppInfoContent>
		</AppInfoContainer>
	);
}
